import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { loadCities, loadCountries, loadCounties } from '../actionCreators';
import { Grid } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import OfferPartnerAddress from './OfferPartnerAddress';
import { getCountiesByCountryId, getCountiesLoadedByCountryId, getCountiesLoadingByCountryId } from '../selectors';
import { Typography } from '@totalsoft/rocket-ui';
import { GapGrid } from 'components/common/CommonStyles';

const OfferPartnerAddressContainer = ({
  address,
  config,
  onPropertyChange,
  counties,
  countiesLoaded,
  countiesLoading,
  countries,
  partnerTypeCode,
  disabled,
  checkMandatoryFields,
  validationInfo,
  actions,
  index,
  onDeleteAddress
}) => {
  const countyIdRef = useRef();

  useEffect(() => {
    actions.loadCountries();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!countiesLoaded && !countiesLoading) {
      if (address && address.country && address.country.id) actions.loadCounties('', address.country.id);
      else actions.loadCounties('', config.defaultCountry.id);
    }
    if (address && address.county && address.county.id) countyIdRef.current = address.county.id;
  }, [countiesLoaded, countiesLoading, actions, config.defaultCountry.id, address]);

  const loadCities = input => actions.loadCities(input, countyIdRef.current);
  const addressTitle = (
    <GapGrid container alignItems='center' my={1} gap={1} direction='row'>
      <PlaceIcon />
      <Typography variant='h6' m={0}>
        {address.addressTypeName}
      </Typography>
    </GapGrid>
  );

  return (
    <>
      <Grid item xs={12}>
        {addressTitle}
      </Grid>
      <OfferPartnerAddress
        onPropertyChange={onPropertyChange}
        index={index}
        loadCities={loadCities}
        config={config}
        address={address}
        counties={counties}
        countries={countries}
        disabled={disabled}
        checkMandatoryFields={checkMandatoryFields}
        validationInfo={validationInfo}
        partnerTypeCode={partnerTypeCode}
        onDeleteAddress={onDeleteAddress}
      />
    </>
  );
};

OfferPartnerAddressContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  address: PropTypes.object.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  counties: PropTypes.array.isRequired,
  countiesLoaded: PropTypes.bool.isRequired,
  countiesLoading: PropTypes.bool.isRequired,
  countries: PropTypes.array.isRequired,
  config: PropTypes.object.isRequired,
  partnerTypeCode: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  checkMandatoryFields: PropTypes.bool.isRequired,
  validationInfo: PropTypes.object.isRequired,
  index: PropTypes.number,
  onDeleteAddress: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  const countryId = ownProps.address.country?.id || state.offerConfig.defaultCountry.id;
  return {
    counties: getCountiesByCountryId(state, countryId),
    countiesLoaded: getCountiesLoadedByCountryId(state, countryId),
    countiesLoading: getCountiesLoadingByCountryId(state, countryId),
    countries: state.clientData.countries,
    config: state.offerConfig
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadCities,
        loadCountries,
        loadCounties
      },
      dispatch
    ),
    dispatch
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(OfferPartnerAddressContainer);
